"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signupApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.signupApiToken = function (fields, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/account/registerbyemail",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: fields,
    });
};
